(() => {
  if (window.htDynamicReady) return;
  window.htDynamicReady = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches || window.Shopify?.designMode) return;
  const main = document.getElementById('MainContent');
  if (!main || !Element.prototype.animate) return;
  const active = new Set();
  const seen = new WeakSet();
  const animate = (element, delay = 0, aboveFold = false) => {
    if (seen.has(element) || reduced.matches) return;
    seen.add(element);
    const frames = aboveFold
      ? [{ transform: 'translateY(14px)' }, { transform: 'translateY(0)' }]
      : [{ opacity: .25, transform: 'translateY(26px)' }, { opacity: 1, transform: 'translateY(0)' }];
    const animation = element.animate(frames, { duration: 620, delay, easing: 'cubic-bezier(.22,.7,.25,1)', fill: 'backwards' });
    active.add(animation);
    animation.finished.then(() => active.delete(animation)).catch(() => active.delete(animation));
  };
  const targets = '.htc-drop,.htc-collection__head,.card-wrapper,.ht-producers article,.ht-reassurance__item,.ht-local-panel,.ht-shopping-guide details,.ht-producers__head,.collection__title,.collection-hero__title,.ht-shopping-guide > h2';
  let observer;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      const visible = entries.filter(entry => entry.isIntersecting);
      visible.forEach((entry, index) => {
        animate(entry.target, Math.min(index, 3) * 65);
        observer.unobserve(entry.target);
      });
    }, { threshold: .08, rootMargin: '0px 0px -24px 0px' });
  }
  const scan = root => {
    root.querySelectorAll(targets).forEach(element => {
      if (seen.has(element)) return;
      const rect = element.getBoundingClientRect();
      if (rect.top < innerHeight && rect.bottom > 0) animate(element, 0, true);
      else observer?.observe(element);
    });
  };
  const start = () => {
    main.querySelectorAll('.ht-storefront-hero__copy .ht-eyebrow,.ht-storefront-hero__copy h2,.ht-storefront-hero__intro,.ht-actions,.ht-hero-facts').forEach((element,index) => animate(element, index * 65, true));
    scan(main);
  };
  try {
    if (document.body.classList.contains('age-locked') || localStorage.getItem('hiddenTerpsAgeAccepted') !== 'yes') document.addEventListener('ht:age-accepted', start, { once: true });
    else start();
  } catch (error) { start(); }
  let mutationFrame;
  const mutations = new MutationObserver(records => {
    if (!records.some(record => record.addedNodes.length)) return;
    if (mutationFrame) return;
    mutationFrame = requestAnimationFrame(() => { mutationFrame = null; scan(main); });
  });
  mutations.observe(main, { childList: true, subtree: true });
  const progress = document.getElementById('ht-reading-progress');
  const visual = main.querySelector('.ht-storefront-hero__visual');
  let scrollFrame;
  const updateScroll = () => {
    scrollFrame = null;
    if (reduced.matches) return;
    const max = document.documentElement.scrollHeight - innerHeight;
    if (progress) progress.style.transform = `scaleX(${max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 0})`;
    if (visual && matchMedia('(min-width: 750px)').matches) {
      const rect = visual.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < innerHeight) visual.style.setProperty('--ht-drift', `${Math.max(-8,Math.min(8,(innerHeight / 2 - rect.top - rect.height / 2) * .025))}px`);
    }
  };
  const onScroll = () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScroll); };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  updateScroll();
  if (visual) {
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    let pointerFrame;
    visual.addEventListener('pointermove', event => {
      if (!fine.matches || reduced.matches) return;
      cancelAnimationFrame(pointerFrame);
      pointerFrame = requestAnimationFrame(() => {
        const rect = visual.getBoundingClientRect();
        visual.style.setProperty('--ht-tilt-x', `${-(event.clientY - rect.top - rect.height / 2) / rect.height * 4}deg`);
        visual.style.setProperty('--ht-tilt-y', `${(event.clientX - rect.left - rect.width / 2) / rect.width * 4}deg`);
      });
    }, { passive: true });
    visual.addEventListener('pointerleave', () => {
      cancelAnimationFrame(pointerFrame);
      visual.style.setProperty('--ht-tilt-x', '0deg');
      visual.style.setProperty('--ht-tilt-y', '0deg');
    });
  }
  reduced.addEventListener('change', event => {
    if (!event.matches) return;
    observer?.disconnect();
    mutations.disconnect();
    active.forEach(animation => animation.cancel());
    active.clear();
    document.getElementById('ht-brand-intro')?.setAttribute('hidden', '');
  });
})();

/* ===== HIDDEN TERPS VIVID (3 nov. 2026) ===== */
(() => {
  const run = () => {
    if (window.htVividReady) return;
    window.htVividReady = true;
    const body = document.body;
    const main = document.getElementById('MainContent');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    const template = main?.dataset.template || '';

    if (main && template !== 'index' && !document.querySelector('.ht-ticker')) {
      const items = ['Low THC · High Terps', 'Livraison offerte dès 69 €', 'Producteurs français identifiés', 'Préparation sous 24 à 48 h', 'Livraison locale Monts du Lyonnais'];
      const ticker = document.createElement('div');
      ticker.className = 'ht-ticker';
      ticker.setAttribute('aria-hidden', 'true');
      const track = document.createElement('div');
      track.className = 'ht-ticker__track';
      for (let i = 0; i < 4; i++) items.forEach(text => { const span = document.createElement('span'); span.textContent = text; track.appendChild(span); });
      ticker.appendChild(track);
      main.before(ticker);
    }

    const ribbon = document.querySelector('.htc-ribbon');
    if (ribbon && !ribbon.classList.contains('is-marquee')) {
      const spans = [...ribbon.children];
      const track = document.createElement('div');
      track.className = 'htc-ribbon__track';
      for (let i = 0; i < 4; i++) spans.forEach(span => track.appendChild(span.cloneNode(true)));
      ribbon.replaceChildren(track);
      ribbon.classList.add('is-marquee');
    }

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; body.classList.toggle('ht-scrolled', scrollY > 40); });
    };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const titleSelector = '.collection__title h2,.collection-hero__title,.title-wrapper-with-link .title,.main-page-title,.ht-producers h2,.ht-shopping-guide h2';
    const lit = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-lit');
      lit.unobserve(entry.target);
    }), { threshold: .4 }) : null;
    const scan = root => {
      root.querySelectorAll(titleSelector).forEach(title => {
        if (title.dataset.htLit) return;
        title.dataset.htLit = '1';
        if (lit && !reduced.matches) lit.observe(title); else title.classList.add('is-lit');
      });
      root.querySelectorAll('.card-wrapper .card').forEach(card => {
        if (card.querySelector(':scope > .ht-glow')) return;
        const glow = document.createElement('span');
        glow.className = 'ht-glow';
        glow.setAttribute('aria-hidden', 'true');
        card.appendChild(glow);
      });
    };
    if (main) {
      scan(main);
      let frame;
      new MutationObserver(() => {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = null; scan(main); });
      }).observe(main, { childList: true, subtree: true });
    }

    let pointerFrame;
    document.addEventListener('pointermove', event => {
      if (!fine.matches || reduced.matches) return;
      const card = event.target.closest?.('.card-wrapper .card');
      if (!card) return;
      cancelAnimationFrame(pointerFrame);
      pointerFrame = requestAnimationFrame(() => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        card.style.setProperty('--mx', `${x * 100}%`);
        card.style.setProperty('--my', `${y * 100}%`);
        card.style.setProperty('--rx', `${(0.5 - y) * 6}deg`);
        card.style.setProperty('--ry', `${(x - 0.5) * 6}deg`);
      });
    }, { passive: true });
    document.addEventListener('pointerout', event => {
      const card = event.target.closest?.('.card-wrapper .card');
      if (!card || card.contains(event.relatedTarget)) return;
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();

/* ===== HIDDEN TERPS DETAILS (3 nov. 2026) : retour en haut, barre livraison offerte, onglet ===== */
(() => {
  const run = () => {
    if (window.htDetailsReady) return;
    window.htDetailsReady = true;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');

    const style = document.createElement('style');
    style.id = 'ht-details-style';
    style.textContent = `
.ht-top{position:fixed;right:18px;bottom:22px;z-index:40;width:52px;height:52px;padding:0;border:0;border-radius:50%;background:rgba(12,17,14,.85);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);box-shadow:0 10px 28px #0008;cursor:pointer;opacity:0;visibility:hidden;transform:translateY(16px) scale(.9);transition:opacity .3s,transform .3s cubic-bezier(.22,.7,.25,1),visibility .3s,background .25s}
.ht-top.is-visible{opacity:1;visibility:visible;transform:none}
.ht-top svg{display:block;width:100%;height:100%}
.ht-top__track,.ht-top__ring{fill:none;transform:rotate(-90deg);transform-origin:26px 26px}
.ht-top__track{stroke:#c9cfcb33;stroke-width:2}
.ht-top__ring{stroke:#c5e86c;stroke-width:2.5;stroke-linecap:round}
.ht-top__arrow{fill:none;stroke:#f2ebdf;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round;transition:transform .3s}
.ht-top:focus-visible{outline:2px solid #c5e86c;outline-offset:4px}
@media(hover:hover){.ht-top:hover{background:#c5e86c}.ht-top:hover .ht-top__arrow,.ht-top:hover .ht-top__ring{stroke:#0e1610}.ht-top:hover .ht-top__arrow{transform:translateY(-3px)}.ht-top:hover .ht-top__track{stroke:#0e161026}}
@media(max-width:749px){.ht-top{width:46px;height:46px;right:14px;bottom:18px}body:has(ht-quick-buy:not([hidden])) .ht-top{bottom:94px}}
body:has(cart-drawer.active) .ht-top,body.age-locked .ht-top,body.ht-drop-lock .ht-top{opacity:0;visibility:hidden}
.ht-ship{margin:0 0 16px;padding:12px 14px;border:1px solid #c5e86c33;border-radius:14px;background:linear-gradient(120deg,rgba(197,232,108,.10),rgba(197,232,108,0))}
.ht-ship__text{margin:0 0 9px;font-size:13px;line-height:1.4;letter-spacing:0;color:#f2ebdf}
.ht-ship__text strong{color:#c5e86c}
.ht-ship__bar{height:6px;border-radius:99px;background:#26332a;overflow:hidden}
.ht-ship__bar span{display:block;height:100%;border-radius:inherit;background:linear-gradient(90deg,#8fbf45,#c5e86c);transition:width .6s cubic-bezier(.22,.7,.25,1)}
.ht-ship.is-done .ht-ship__bar span{box-shadow:0 0 12px #c5e86c}
#CartDrawer .ht-ship{margin:0 0 8px}
.rte a{color:#c5e86c;text-decoration-color:#c5e86c66}
@media(prefers-reduced-motion:no-preference){html{scroll-behavior:smooth}}
@media(prefers-reduced-motion:reduce){.ht-top,.ht-top__arrow,.ht-ship__bar span{transition:none}}
`;
    document.head.appendChild(style);

    const top = document.createElement('button');
    top.type = 'button';
    top.className = 'ht-top';
    top.setAttribute('aria-label', 'Remonter en haut de la page');
    top.innerHTML = '<svg viewBox="0 0 52 52" aria-hidden="true" focusable="false"><circle class="ht-top__track" cx="26" cy="26" r="23"/><circle class="ht-top__ring" cx="26" cy="26" r="23"/><path class="ht-top__arrow" d="M26 34V19m-7 7 7-7 7 7"/></svg>';
    document.body.appendChild(top);
    const ring = top.querySelector('.ht-top__ring');
    const length = 2 * Math.PI * 23;
    ring.style.strokeDasharray = String(length);
    let frame;
    const update = () => {
      frame = null;
      const max = document.documentElement.scrollHeight - innerHeight;
      const progress = max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 0;
      ring.style.strokeDashoffset = String(length * (1 - progress));
      top.classList.toggle('is-visible', scrollY > innerHeight * 0.6);
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', queue, { passive: true });
    update();
    top.addEventListener('click', () => {
      scrollTo({ top: 0, behavior: reduced.matches ? 'auto' : 'smooth' });
      document.querySelector('.header__heading-link')?.focus({ preventScroll: true });
    });

    const FREE_SHIPPING = 6900;
    const money = cents => (cents / 100).toFixed(2).replace('.', ',').replace(',00', '') + '\u00a0€';
    const spots = () => [document.querySelector('#CartDrawer .drawer__header'), document.querySelector('cart-items .title-wrapper-with-link')].filter(Boolean);
    const render = cart => {
      spots().forEach(spot => {
        let bar = spot.nextElementSibling?.classList.contains('ht-ship') ? spot.nextElementSibling : null;
        if (!cart.item_count) { bar?.remove(); return; }
        if (!bar) {
          bar = document.createElement('div');
          bar.className = 'ht-ship';
          bar.setAttribute('role', 'status');
          bar.innerHTML = '<p class="ht-ship__text"></p><div class="ht-ship__bar"><span style="width:0"></span></div>';
          spot.after(bar);
        }
        const left = FREE_SHIPPING - cart.total_price;
        bar.classList.toggle('is-done', left <= 0);
        bar.querySelector('.ht-ship__text').innerHTML = left > 0
          ? `Plus que <strong>${money(left)}</strong> pour la livraison Colissimo offerte`
          : '<strong>✓ Livraison Colissimo offerte</strong> débloquée !';
        requestAnimationFrame(() => { bar.querySelector('.ht-ship__bar span').style.width = `${Math.min(100, cart.total_price / FREE_SHIPPING * 100)}%`; });
      });
    };
    let timer;
    const refresh = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (!spots().length) return;
        fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })
          .then(response => response.ok ? response.json() : null)
          .then(cart => { if (cart) render(cart); })
          .catch(() => {});
      }, 200);
    };
    const watch = element => {
      if (!element) return;
      new MutationObserver(records => {
        if (records.every(record => record.target.closest?.('.ht-ship') || [...record.addedNodes].every(node => node.classList?.contains('ht-ship')))) return;
        refresh();
      }).observe(element, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    };
    watch(document.querySelector('cart-drawer'));
    watch(document.querySelector('cart-items'));
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh);
    refresh();

    const originalTitle = document.title;
    document.addEventListener('visibilitychange', () => {
      document.title = document.hidden ? '🌿 Tes terpènes t’attendent…' : originalTitle;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
